import EventDeliveryList from './event-delivery-view';

const EventDeliveryPage = {
    name: 'EventDelivery',
    list: EventDeliveryList
};
export default EventDeliveryPage;